import { Lightning } from '@lightningjs/sdk';
import { ROW_LIST_OFFSET_Y } from 'components/common/carousels/Carousel';
import { LiveEventCarousel } from 'components/common/carousels/LiveEventCarousel';
import { LiveEventStream } from 'types/api/media';
import { translate } from 'support/translate';
import LiveEventTile from 'components/common/tiles/LiveEventTile';

export interface LiveEventRecommendedSectionPageSpec
  extends Lightning.Component.TemplateSpec {
  liveEvents: LiveEventStream[];

  RecommendedList: typeof LiveEventCarousel;
}

const HORIZONTAL_MARGIN = 96;
const VERTICAL_MARGIN = 40;

export default class LiveEventRecommendedSection
  extends Lightning.Component<LiveEventRecommendedSectionPageSpec>
  implements
    Lightning.Component
      .ImplementTemplateSpec<LiveEventRecommendedSectionPageSpec>
{
  private _RecommendedList = this.getByRef('RecommendedList')!;

  static get h() {
    return LiveEventTile.height + ROW_LIST_OFFSET_Y + VERTICAL_MARGIN * 2;
  }

  get index() {
    return this._RecommendedList.index;
  }

  get label() {
    return this._RecommendedList.label;
  }

  set liveEvents(liveEvents: LiveEventStream[]) {
    this._RecommendedList.patch({
      visible: !!liveEvents.length,
      label: translate('liveEventDetail.moreLiveEvents'),
      laneItems: liveEvents,
    });
  }

  static override _template(): Lightning.Component.Template<LiveEventRecommendedSectionPageSpec> {
    return {
      RecommendedList: {
        type: LiveEventCarousel,
        // @ts-ignore
        listType: LiveEventTile,
        x: HORIZONTAL_MARGIN,
        y: VERTICAL_MARGIN,
        w: 1920 - 2 * HORIZONTAL_MARGIN,
        imageKey: 'eventThumbnail',
        itemWidth: LiveEventTile.width,
        signals: {
          $onHover: '$onHover',
        },
        navBarOffset: HORIZONTAL_MARGIN,
        isNavBarVisible: false,
      },
    };
  }

  override _getFocused() {
    return this._RecommendedList;
  }

  $onHover() {
    this.signal('$onHover', this);
  }
}
